module.exports = __webpack_public_path__ + "img/ic-stats-hover.b577836e.svg";